export const listHiddenHeader = [
  '',
  '/',
  '/replenishment',
  '/replenishment/',
  '/transfer',
  '/transfer/',
  '/success-transfer',
  '/success-transfer/',
  '/fail-transfer',
  '/fail-transfer/',
];
